<brd-hero-image></brd-hero-image>
<brd-maintenance-alert></brd-maintenance-alert>
<div class="section-container">
  <div class="title">
    <span>About Board Demo Portal</span>
  </div>
  <div class="about-container">
    <div class="subtitle">What is the Board Demo Portal?</div>
    <p>
      The Demo Portal is a service that can be used to demo Board to prospects and customers using a <u>personal</u>, <u>on-demand</u> and
      <u>always up-to-date</u> demo environment.
    </p>
    <p>
      <b>It can also be used for customized demos </b>
      <u>as it can retain changes made to the standard demos and can be accessed multiple times across multiple weeks.</u> For more
      information about the demos availability see the ‘Is the Demo always available?’ in the FAQ section.
    </p>
    <p>
      <b
        >While the Demo Portal is best suited for standard or slightly customized demos, more complex scenarios and edits require a
        dedicated POC environment:
      </b>
    </p>
    <ul>
      <li>
        <b
          >if you are a Board employee, please request
          <a
            href="https://boardint.seismic.com/app#/doccenter/2c538005-2da9-4703-b41c-ffdced4836c7/doc/%252Fdda6404bda-1862-b8d4-6fca-e9f2ef7eeae5%252Fddbff1b445-4000-be2f-773a-1bc2e93a37d3%252FdfNDU2YmRjZTQtNzVjNi00YmU0LWEwNjktMDliMTgwZTM1MDM3%252CPT0%253D%252CRW5hYmxlbWVudA%253D%253D%252Flfad98ea38-e3fc-420f-ab79-aecfdbb35011//?mode=view&searchId=91fcca9c-2860-477e-b67e-d36140d0bce4"
            target="_blank"
            >a dedicated POC Environment</a
          >
          following
          <a
            href="https://boardint.seismic.com/app#/doccenter/2c538005-2da9-4703-b41c-ffdced4836c7/doc/%252Fdd42222727-ac65-15d0-5c28-491920099380%252Fdd01a102c1-81f0-a4d8-aae0-71d796838cc8%252Flf8c36358f-7c83-46b5-8cba-6e16f6f09eb1//?mode=view&searchId=931b3fdd-effb-4ef1-a1e9-c5f4080f393c"
            target="_blank"
            >the procedure.</a
          >
        </b>
      </li>
      <li>
        <b>if you are a partner, please contact your Partner Success Manager and the Key Account Manager:</b> they will assist you in
        processing the request.
      </li>
    </ul>
    <p>Within the Demo Portal, you have the ability to create an individual demo out of multiple demos or use suggested presets.</p>
    <p>
      New templates and demos will be added periodically: all content will always be up-to date and synched to the most recent Board version
      patches. Make sure to keep an eye on the News section to check what’s new!
    </p>
    <div class="subtitle">How to use the Demo Portal?</div>
    <p class="image-container">
      <span>
        Once logged in, you will find a gallery of <b>Single Demos</b> and <b>Suggested Sets</b> available. You can
        <b>filter on specific Use Cases, Processes, Domains, Functionalities and Industries.</b> You can create a collection of single demos
        to perfectly fit your needs or directly choose a suggested set of included demos. <br /><br />
        When creating a <b>collection of single demos</b> simply add the demos you want to your collection and click on CREATE. Fill in the
        necessary information about the demo instance and create your dedicated <b>Demo Environment.</b>
      </span>
      <img src="assets/images/about/Picture1.gif" alt="Picture1" height="300px" />
    </p>
    <p class="image-container">
      <img src="assets/images/about/Picture2.gif" alt="Picture2" height="300px" />
      <span>
        For a suggested set you only need to click on <b>CREATE DEMO INSTANCE</b>, fill in the necessary information and the dedicated demo
        environment corresponding to the set will be created. <br /><br />
        It takes <b>less than a few minutes</b> to create your demo environment! You will be notified via email as soon as the demo is
        created. <br /><br />
        An <b>online tutorial</b> on is available at this
        <a href="https://academy.board.com/demo-portal-tutorial" target="_blank">link</a>
      </span>
    </p>
  </div>
</div>
<brd-contact-support></brd-contact-support>
